'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var processLogin = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref2) {
    var auth = _ref2.auth,
        setStage = _ref2.setStage,
        account = _ref2.account,
        password = _ref2.password,
        history = _ref2.history;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setStage('fetching');
            _context.prev = 1;
            _context.next = 4;
            return auth.login(account, password);

          case 4:
            setStage('success');
            history.push('/');
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);

            console.error(_context.t0);
            setStage(_context.t0);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 8]]);
  }));

  return function processLogin(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _Login = require('./Login');

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var messageSet = {
  init: {},
  fetching: {
    message: '登入中...',
    messageStyle: 'info'
  },
  success: {
    message: '登入成功',
    messageStyle: 'success'
  },
  fail: {
    message: '帳號或密碼錯誤',
    messageStyle: 'danger'
  },
  error: {
    message: '狀態異常!請檢查網路連線或與維護人員連絡',
    messageStyle: 'danger'
  }
};

var shape = _propTypes2.default.shape,
    func = _propTypes2.default.func;

var enhancer = (0, _compose2.default)((0, _setPropTypes2.default)({
  auth: shape({
    login: func.isRequired
  }),
  history: shape({
    push: func.isRequired
  })
}), (0, _withState2.default)('account', 'setAccount', ''), (0, _withState2.default)('password', 'setPassword', ''), (0, _withState2.default)('stage', 'setStage', 'init'), (0, _withHandlers2.default)({
  login: function login(props) {
    return function () {
      return processLogin(props);
    };
  }
}), (0, _withProps2.default)(function (_ref3) {
  var stage = _ref3.stage;
  return _extends({}, messageSet[stage]);
}));

exports.default = enhancer(_Login2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Login/index.js
// module id = 762
// module chunks = 0